module.exports = __webpack_public_path__ + "img/fashion_52.394f3b96.jpg";